import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { LieferantenQuery } from '../types/lieferanten-query';
import { LieferantenRepository } from '../repositories/lieferanten.repository';
import { SupplierIdService } from './supplier-id.service';
import { Supplier } from '@softapps/wws/core';

@Injectable()
export class LieferantenService extends ReadonlyRepositoryObjectService<
  Supplier,
  Result<Supplier>,
  LieferantenQuery
> {
  readonly #supplierIdService = inject(SupplierIdService);

  supplierId = computed(() => this.#supplierIdService.supplierId()());
  override params = computed(() => {
    return { id: this.supplierId() };
  });

  constructor() {
    super(inject(LieferantenRepository));
  }

  protected override getValue(result: Result<Supplier> | null | undefined): Supplier {
    return result as any;
  }
}
